import { Component, EventEmitter, Input, Output } from '@angular/core';

// INTERFACES
import { IWarehouseGroup } from '../../../shared/interfaces';
import { trackById } from '../../../shared/util';
import { EPickAndPackEnabledValue } from '../../interfaces/location.interface';

// SHARED

@Component({
  selector: 'lum-location-warehouse-group-table',
  templateUrl: './location-warehouse-group-table.component.html',
  styleUrls: ['./location-warehouse-group-table.component.scss'],
})
export class LocationWarehouseGroupTableComponent {
  @Input()
  data :IWarehouseGroup[] = [];

  @Input()
  loading :boolean = false;

  @Output()
  openDialog = new EventEmitter<IWarehouseGroup>();

  @Output()
  deleteEvent = new EventEmitter<number>();

  @Input() ftPickAndPackEnabled :boolean = false;
  ePickAndPackEnabledValue = EPickAndPackEnabledValue;
  trackById = trackById;

  onDelete(warehouseGroupId :number) :void {
    this.deleteEvent.emit(warehouseGroupId);
  }

  onOpenDialog(warehouseGroup :IWarehouseGroup) :void {
    this.openDialog.emit(warehouseGroup);
  }
}
